import store from '../store';
import Actions from '../actions/indexExport';
import {getCurrentUserId} from '../../lib/picos/currentLogin';
import newHRTimestamp from '../../lib/picos/timestamp';
import {findAll} from "../find";
import Referral from '../../entities/referral';

/*
 * Delete/nullify anywhere this referral is used in other entities
 *
 * @param {Referral} referral
 */
export function deleteReferral(referral: Referral, mergeId?: string) {
    let targetImportSource = 'merge';

    if (!mergeId) {
        targetImportSource = 'delete';
        mergeId = referral.id;
    }

    /* Remove the actual referral */
    referral.status = 'D';
    referral.addedOn = newHRTimestamp();
    referral.addedBy = getCurrentUserId();
    referral.importSource = targetImportSource;
    referral.importId = mergeId;
    store.dispatch(Actions.ReferralActions.removeReferralQueue(referral));
    
}